/**
 * BookWorm JS
 *
 * @author MadrasThemes
 * @version 1.0
 * @requires
 *
 */

;
(function ($) {
	$(document).ready(function () {

		if ($.HSCore.components.HSUnfold !== undefined) {
			// Initialization of unfold component
			$.HSCore.components.HSUnfold.init($('[data-unfold-target]'));
		}

		if ($.HSCore.components.HSSlickCarousel !== undefined) {
			// initialization of slick carousel
			$.HSCore.components.HSSlickCarousel.init('.js-slick-carousel');
		}

		if ($.HSCore.components.HSCubeportfolios !== undefined) {
			// initialization of cubeportfolio
			$.HSCore.components.HSCubeportfolio.init('.cbp');
		}
		// initialization of show animations
		$.HSCore.components.HSShowAnimation.init('.js-animation-link');

		if ($.HSCore.components.HSSelectPicker !== undefined) {
			// initialization of select picker
			$.HSCore.components.HSSelectPicker.init('.js-select');
		}
		var zeynep = $('.zeynep').zeynep({
			onClosed: function () {
				// enable main wrapper element clicks on any its children element
				$("body main").attr("style", "");

				console.log('the side menu is closed.');
			},
			onOpened: function () {
				// disable main wrapper element clicks on any its children element
				$("body main").attr("style", "pointer-events: none;");

				console.log('the side menu is opened.');
			}
		});

		// handle zeynep overlay click
		$(".zeynep-overlay").click(function () {
			zeynep.close();
		});

		// open side menu if the button is clicked
		$(".cat-menu").click(function () {
			if ($("html").hasClass("zeynep-opened")) {
				zeynep.close();
			} else {
				zeynep.open();
			}
		});
	});
})(jQuery);

